// TermsModal.jsx
import React, { useState } from 'react';
import { MdOutlineLibraryBooks } from "react-icons/md";

const TermsModal = ({ isOpen, onClose }) => {
    // Expanded list of terms for an e-commerce bulk orders platform for construction materials
    const [terms] = useState([
        { id: 1, term: "Eligibility: Customers must be 18 years or older to use our services." },
        { id: 2, term: "Account Registration: Provide accurate and up-to-date information during registration." },
        { id: 3, term: "Order Placement: All orders are subject to acceptance and confirmation. Bulk orders require a minimum purchase quantity as specified on the product page." },
        { id: 4, term: "Pricing and Payment: Prices are subject to change without notice. All payments must be made through our approved payment channels." },
        { id: 5, term: "Third-Party Sellers: Our platform hosts products offered by third-party sellers. While we facilitate transactions, we are not responsible for the quality, availability, or delivery of these products." },
        { id: 6, term: "Shipping and Delivery: Shipping fees and delivery times are provided by the sellers and carriers. Please review shipping details carefully before placing an order." },
        { id: 7, term: "Returns and Refunds: Return and refund policies vary by seller. Please review the specific policy associated with each product or contact the seller directly." },
        { id: 8, term: "Bulk Order Requirements: Bulk orders are subject to minimum quantity requirements and may incur different pricing. Review these details before placing your order." },
        { id: 9, term: "Liability: We are not liable for any damages, losses, or disputes arising from transactions with third-party sellers. Customers agree to hold us harmless in such events." },
        { id: 10, term: "Modification of Terms: We reserve the right to modify these terms at any time. Changes will be posted on our website and become effective immediately." },
        { id: 11, term: "Governing Law: These terms are governed by and construed in accordance with the applicable laws in our operating jurisdiction." }
    ]);

    // Ensure hooks are always called in the same order
    if (!isOpen) return null;

    return (
        <>
            {/* Inline CSS for custom scrollbar styling */}
            <style>
                {`
          .scrollbar-custom::-webkit-scrollbar {
            width: 8px;
          }
          .scrollbar-custom::-webkit-scrollbar-track {
            background: #f1f1f1;
          }
          .scrollbar-custom::-webkit-scrollbar-thumb {
            background-color: #FFAE00;
            border-radius: 4px;
            border: 2px solid #f1f1f1;
          }
          /* For Firefox */
          .scrollbar-custom {
            scrollbar-width: thin;
            scrollbar-color: #FFAE00 #f1f1f1;
          }
        `}
            </style>

            {/* Modal Container */}
            <div className="fixed inset-0 flex items-center justify-center z-50">
                {/* Backdrop */}
                <div
                    className="absolute inset-0 bg-black opacity-50"
                    onClick={onClose}
                ></div>
                {/* Modal Content */}
                <div className="relative bg-white rounded-lg shadow-lg h-[75vh] w-11/12 md:w-1/3 p-6 z-50 flex flex-col">
                    {/* Header */}
                    <div className="flex justify-center items-center mb-4">
                        <MdOutlineLibraryBooks className="text-5xl text-[#FFAE00]" />
                        <div className="ml-4">
                            <h2 className="text-lg font-bold mb-1">Terms and Policy</h2>
                            <p className="text-sm text-gray-600">Last update on 00/00/2025</p>
                        </div>
                    </div>
                    <hr className="mb-4" />
                    {/* Scrollable Terms Content */}
                    <div className="flex-1 overflow-y-auto scrollbar-custom text-sm px-2">
                        <ol className="list-decimal pl-6 marker:text-black marker:font-semibold">
                            {terms.map((item) => (
                                <li key={item.id} className="mb-2 text-gray-500">
                                    {item.term}
                                </li>
                            ))}
                        </ol>
                    </div>

                    {/* Close Button */}
                    <div className="mt-4 flex justify-end gap-2">
                        {/* <button
                            onClick={onClose}
                            className="px-4 py-2 border-solid border-gay-500 border-2 text-gray-600 rounded-md"
                        >
                            Decline
                        </button>
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-[#FFAE00] text-white rounded-md"
                        >
                            Accept
                        </button> */}
                        <button
                            onClick={onClose}
                            className="px-4 py-2 bg-[#FFAE00] text-white rounded-md"
                        >
                            Close
                        </button>

                    </div>
                </div>
            </div>
        </>
    );
};

export default TermsModal;
